import { Component, computed, input } from '@angular/core';

import { CmsDestination } from '@fcom/core-api';

@Component({
  selector: 'cms-ond-marketing-offers-list',
  template: ` <fin-ond-marketing-offers-list [destinationLocationCode]="destinationLocationCode()" /> `,
  standalone: false,
})
export class CmsOndMarketingOffersListComponent {
  readonly content = input.required<CmsDestination>();

  readonly destinationLocationCode = computed(() => {
    return this.content()?.locationCode;
  });
}
